"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.icon.help': 'Inserisci classe icona FontAwesome (es. fas fa-folder)',
};
